import 'moment/dist/locale/pt-br'
import moment from 'moment-timezone';
export default {
  install: (app) => {
    moment.locale('pt-br');
    moment.tz.setDefault('America/Sao_Paulo');
    app.config.globalProperties.$moment = moment; 
  },
};